import { QueryClient } from '@tanstack/react-query';

/**
 * Клиент запросов интерфейса. Повторов нет: ошибка сразу показывается с кодом (FR-032). Для 401 и 403 это обязательно —
 * повтор не даст ни входа, ни роли, только поток запросов к серверу. Перезапроса при возврате на вкладку тоже нет.
 */
export function makeQueryClient(): QueryClient {
  return new QueryClient({ defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } } });
}
